// extracted by mini-css-extract-plugin
module.exports = {"campaignReportTableBody":"CampaignReportTableBody_campaignReportTableBody__kbPbp"};